/** Foca o campo de mensagem ao cliente na conversa aberta. */
export function focusClientComposer() {
  if (typeof document === "undefined") return;

  const el =
    document.querySelector('[data-xpro-client-compose="true"]') ||
    document.querySelector("textarea[placeholder*='Mensagem']");

  if (!el) return;

  el.scrollIntoView({ behavior: "smooth", block: "nearest" });
  queueMicrotask(() => {
    try {
      el.focus({ preventScroll: true });
    } catch {
      el.focus();
    }
  });
}
